import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Empresa from './Empresa'
import Token from './Token'

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography component={'span'} >{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const codEmpresa = React.useMemo(() => {
    if (props.codEmpresa) return props.codEmpresa
    if (props.data && props.id) {
      const emp = props.data.find(e => e.id === props.id)
      if (emp) return emp.cod_empresa
    }
    return null
  }, [props.codEmpresa, props.data, props.id])

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Dados" {...a11yProps(0)} />
          {props.id ? <Tab label="Tokens" {...a11yProps(1)} /> : null}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Empresa codEmpresa={codEmpresa} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Token empresa_id={props.id} showNotify={props.showNotify} />
      </TabPanel>
    </Box>
  );
}
